var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.$store.state.displayType === "textual"
    ? _c("default-textual-section", {
        staticClass: "menu--section-romanza",
        attrs: {
          menu: _vm.menu,
          section: _vm.section,
          "menu-item-component": _vm.menuItemComponent.length
            ? _vm.menuItemComponent
            : "romanza-default-item",
          "is-title-buffer-visible": "",
          "menu-item-tag-location": _vm.menuItemTagLocation,
        },
      })
    : _c("default-visual-section", {
        staticClass: "menu--section-romanza",
        attrs: {
          menu: _vm.menu,
          section: _vm.section,
          "menu-item-component": _vm.menuItemComponent.length
            ? _vm.menuItemComponent
            : "romanza-default-item",
          "is-title-buffer-visible": "",
          "menu-item-tag-location": _vm.menuItemTagLocation,
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }